import React from 'react';
import { Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CustomReactSelect } from '../../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import routeNames from '../../../../routes/routeNames';

const FilterBar = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { companyOptions, company } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { setCompany } = companyActions;
    
    const handleNavigateToDashboard = () => {
        navigate(routeNames.DASHBOARD);
    };

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
        handleNavigateToDashboard();
    };

    return (
        <>
            <Grid className="flex-row-space-between pb-24px mt-10px">
                <Grid className='d-flex gap-12' xs={6}>
                    {/* Select Inputs */}
                    <Box className="flex-row gap-12"> 
                    {is_admin && (
                        <Box width={300}>
                            <CustomReactSelect
                                options={companyOptions}
                                handleFilter={handleCompanyChange}
                                selectedOption={{
                                    label: company.name,
                                    value: company.id,
                                }}
                                customStyle={{ borderRadius: '50px' }}
                                placeholder="Select Company"
                            />
                        </Box>
                    )}
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default FilterBar;
